import './src/style.css'
import VueAudio from './src/VueAudio.vue'

export default VueAudio
export { VueAudio }
